import { ScoreType, SurveyVersion } from '.';
import { HasId } from '../interfaces';

export class TeamologyClarity implements HasId {
    public id: number;
    public surveyVersionID ?: number;
    public surveyVersion: SurveyVersion;
    public rawScoreOneID ?: number;
    public rawScoreOne: ScoreType;
    public rawScoreTwoID ?: number;
    public rawScoreTwo: ScoreType;
}


// WEBPACK FOOTER //
// ./src/models/TeamologyClarity.tsx